import React, { useEffect, useState, useContext, useCallback } from 'react'
import _ from 'lodash'

import AppConfigContext from '../app_layout/app_config_context'
import { ApiHelper } from '../../helpers/apihelper'
import * as Constants from '../../helpers/constants'
import showToastNotification from '../widgets/toastify'

import AttachedUserList from './attached_user_list'
import OtherUsersList from './other_users_list'

const ProductUsersContainer = ({ planId, product }) => {
  const { client } = useContext(AppConfigContext)
  const [attachedUserIds, setAttachedUserIds] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchAttachedUsers = useCallback(() => {
    if (!client || !planId) return
    // Not every client exposes plan/info (clearoutphone has no such endpoint).
    const getUserPlanInfo = ApiHelper(client, 'PLAN_INFO')
    if (!getUserPlanInfo) return
    setLoading(true)
    const requestQueryParams = {
      product_id: planId,
      crm_user_data: JSON.stringify({}),
      client_secret: Constants.CLIENT_SECRET
    }
    const query = _.pick(requestQueryParams, getUserPlanInfo.API_QUERY)
    getUserPlanInfo.API(client, query)
      .then(res => {
        const users = res?.product_details?.users || []
        setAttachedUserIds(users)
      })
      .catch((err) => {
        console.error(err)
        const message = err?.response?.data?.message || err?.message || 'Something went wrong'
        showToastNotification({ message, isSuccess: false })
      })
      .finally(() => setLoading(false))
  }, [client, planId])

  useEffect(() => {
    fetchAttachedUsers()
  }, [fetchAttachedUsers])
  const handleDetachSuccess = () => {
    fetchAttachedUsers()
  }
  const handleAttachSuccess = () => {
    fetchAttachedUsers()
  }
  const handleCancelSuccess = () => {
    fetchAttachedUsers()
  }
  
  return (
    <>
      <AttachedUserList
        planId={planId}
        attachedUserIds={attachedUserIds}
        loading={loading}
        product={product}
        onDetachSuccess={handleDetachSuccess}
        onCancelSuccess={handleCancelSuccess}
      />
      <OtherUsersList
        planId={planId}
        product={product}
        attachedUserIds={attachedUserIds}
        loading={loading}
        onAttachSuccess={handleAttachSuccess}
        onCancelSuccess={handleCancelSuccess}
      />
    </>
  )
}

export default ProductUsersContainer

